import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const ServerCall = () => {
  const customAxios = axios.create({
    baseURL: BASE_URL,
  });

  const token = localStorage.getItem("token");

  const requestHandler = (request) => {
    if (token) {
      // console.log(token)
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  };

  const responseHandler = (response) => {
    return response;
  };

  const requestErrorHandler = (error) => {
    return Promise.reject(error);
  };

  const responseErrorHandler = (error) => {
    if (error.message === "Network Error" || error.response.status === 401 || error.response.status === 403) {
      localStorage.removeItem("token");
      // localStorage.clear();
      if (!error.config.url.includes("//")) {
        window.location = "/";
      }
    }
    return Promise.reject(error);
  };

  customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => requestErrorHandler(error)
  );

  customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => responseErrorHandler(error)
  );

  return { customAxios };
};

export default ServerCall;
